// src/utils/env.ts
// Safe environment access for both Vite (browser) and Jest/Node

export function getImportMetaEnv(): Record<string, unknown> | undefined {
  try {
    // Avoid static reference so Jest doesn't choke on import.meta
    return (0, eval)('import.meta.env');
  } catch {
    return undefined;
  }
}

export function getEnv(key: string): string | undefined {
  const meta = getImportMetaEnv() as Record<string, string | undefined> | undefined;
  if (meta && key in meta) return meta[key];
  if (typeof process !== 'undefined' && process.env) return process.env[key];
  return undefined;
}

export const isDev: boolean =
  (typeof process !== 'undefined' && process.env.NODE_ENV === 'development') ||
  !!getImportMetaEnv()?.DEV;

export const isTest: boolean =
  typeof process !== 'undefined' && process.env.NODE_ENV === 'test';
